import apiClient from '@/utils/apiClient';

/**
 * Creates a price list or returns an existing one for the same date/type.
 * Optionally copies all products from another list.
 *
 * @param {Object} params
 * @param {string} params.type
 * @param {string} params.dateApplied - YYYY-MM-DD
 * @param {string|null} [params.validFrom] Obligatoriu când se creează o listă nouă.
 * @param {number|string|null} [params.copyFromPriceListId]
 * @returns {Promise<Object>}
 */
export async function createPriceList({
    type,
    dateApplied,
    validFrom = null,
    copyFromPriceListId = null,
}) {
    const response = await apiClient.post('/api/price_lists', {
        type,
        date_applied: dateApplied,
        valid_from: validFrom || null,
        copy_from_price_list_id: copyFromPriceListId || null,
    });
    return response.data;
}

/**
 * Compare frozen product snapshots between two price lists.
 * @param {number|string} leftId
 * @param {number|string} rightId
 * @returns {Promise<Object>}
 */
export async function comparePriceLists(leftId, rightId, options = {}) {
    const response = await apiClient.get('/api/price_lists/compare/', {
        params: {
            left_id: leftId,
            right_id: rightId,
        },
        signal: options.signal,
        timeout: options.timeout ?? 120000,
    });
    return response.data;
}

/**
 * Fetch field-level change history for a price list.
 * @param {number|string} priceListId
 * @param {Object} [params]
 * @param {string} [params.product_code]
 * @param {string} [params.field_path]
 * @param {string} [params.change_type]
 * @param {string} [params.source]
 * @param {string} [params.from]
 * @param {string} [params.to]
 * @param {number} [params.limit]
 * @returns {Promise<{price_list_id: number, count: number, entries: Array}>}
 */
export async function fetchPriceListHistory(priceListId, params = {}) {
    const response = await apiClient.get(`/api/price_lists/${priceListId}/history/`, {
        params,
    });
    return response.data;
}
